import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NotificationsState } from "./notifications.reducer";

export const selectNotificationsState = createFeatureSelector<NotificationsState>("notifications");

export const getNotificationsCount = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.count
);

// SAN-1428 — notification centre counters; null while the flag is off.
export const getNotificationCounters = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.counters
);
